// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"291b20c9","228":"456c98c4","715":"6e4c5cec","856":"291b20c9"}[chunkId] + ".chunk.css";
};